'use client';

import React from 'react';

export const useMountUnmountRef = <T extends HTMLElement>(
  onMount: (element: T) => void,
  onUnmount: (element: T) => void,
): [React.MutableRefObject<T | null>, (node: T) => void] => {
  const nodeRef = React.useRef<T | null>(null);

  const setRef = React.useCallback(
    (node: T) => {
      if (nodeRef.current) {
        onUnmount(nodeRef.current);
      }

      nodeRef.current = node;

      if (nodeRef.current) {
        onMount(nodeRef.current);
      }
    },
    [onMount, onUnmount],
  );

  return [nodeRef, setRef];
};
